export default __webpack_public_path__ + "static/media/crate.1e3b040b.png";